export default __webpack_public_path__ + "efe91fa0fd41f413f422ffdf2277f652.jpg";